<template>
  <div>
    <cooperation-search-head
      :titleInfo="titleInfo"
      :bgUrl="bgUrl"
      @handSearch="handSearch"
      :companyList="companyList"
    >
    </cooperation-search-head>
    <div class="cooperation-contract-index-container">
      <div class="contract-content-head">
        <cooperation-title-cp
          title="合同概览"
          :bg="false"
        ></cooperation-title-cp>
        <cooperation-block-cp></cooperation-block-cp>
      </div>
      <div class="contract-content-body">
        <cooperation-title-cp
          title="我签订的合同"
          :bg="false"
        ></cooperation-title-cp>
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mine-contract-change :item="item"></mine-contract-change>
                <div class="mine-item-bg"></div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationTitleCp from '../components/title-cp';
import cooperationBlockCp from './cooperation-packge/components/cooperation-block-cp';
import mineContractChange from './cooperation-packge/components/cooperation-my-contract-change-cp';
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';
import { Sticky, List, PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';
export default {
  name: 'cooperation-contract-index',

  data() {
    return {
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      providerGuid: '',
      companyList: [],
      params: {},
      titleInfo: {
        selectname: '签约日期',
        selectTitle: '签约日期'
      },
      offsetTop: 0,
      bgUrl: '',
      filterUserCenterUserInfo: {
        employeeName: '测试',
        mobile: '15828097809'
      },
      watertext: '',
      watermobile: ''
    };
  },
  created() {
    let { providerGuid, employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    let params = {
      providerGuid,
      current: this.current,
      size: this.size
    };
    this.providerGuid = providerGuid;

    this.getContractList(params);
    this._getComplay({ type: 'contract' });
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 3);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },

  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    getContractList(params) {
      let { current, providerGuid, size } = this;
      params = { providerGuid, ...params, current, size };
      this.$api.getContractList(params).then(res => {
        let { body } = res;
        let { records } = body;
        if (res.status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handSearch(data) {
      let params = { ...data };
      this.list = [];
      this.current = 1;
      this.params = params;
      this.loading = false;
      this.finished = false;
      this.getContractList(params);
    },
    onLoad() {
      let { params } = this;
      this.current++;
      this.getContractList(params);
    },
    onRefresh() {
      this.list = [];
      this.finished = false;
      this.current = 1;
      let { params } = this;
      this.getContractList(params);
    }
  },
  components: {
    cooperationTitleCp,
    cooperationBlockCp,
    mineContractChange,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  }
};
</script>

<style scoped lang="scss">
.cooperation-contract-index-container {
  margin-top: 10px;
  // height: 400px;
  // border: 1px solid red;
  position: relative;
  z-index: 9;
  .contract-content-body {
    margin-top: 20px;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
    .mine-item {
      background: transparent;
      margin-top: 10px;
      .mine-item-bg {
        background: #efefef;
        height: 10px;
      }
    }
    .mine-item:nth-child(2) {
      margin-top: 0 !important;
    }
  }
  .contract-content-head {
  }
}
</style>
